import script from "./TaskListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskListView.vue?vue&type=script&setup=true&lang=ts"

import "./TaskListView.vue?vue&type=style&index=0&id=bb3d4ae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb3d4ae0"]])

export default __exports__